import { render, staticRenderFns } from "./RoleManagementContainer.vue?vue&type=template&id=310236d8&scoped=true&"
import script from "./RoleManagementContainer.vue?vue&type=script&lang=js&"
export * from "./RoleManagementContainer.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RoleManagementContainer.vue?vue&type=style&index=1&id=310236d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310236d8",
  null
  
)

export default component.exports